import { render, staticRenderFns } from "./SaleTaxCreate.vue?vue&type=template&id=6ff33a10&"
import script from "./SaleTaxCreate.vue?vue&type=script&lang=ts&"
export * from "./SaleTaxCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports